import React from 'react';
import { 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel,
  Box,
  Typography
} from '@mui/material';
import { Calendar } from 'lucide-react';

export const DATE_RANGES = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  LAST_7_DAYS: 'Last 7 Days',
  LAST_30_DAYS: 'Last 30 Days',
  THIS_MONTH: 'This Month',
  LAST_MONTH: 'Last Month',
  LAST_3_MONTHS: 'Last 3 Months',
  LAST_6_MONTHS: 'Last 6 Months',
  THIS_ACADEMIC_YEAR: 'This Academic Year',
  LAST_ACADEMIC_YEAR: 'Last Academic Year',
  ALL_TIME: 'All Time',
  CUSTOM: 'Custom Date Range'
};

export function AnalyticsFilter({ 
  value = DATE_RANGES.TODAY, 
  onChange,
  size = 'small',
  sx = {}
}) {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl size={size} sx={{ minWidth: 200, ...sx }}>
      <Select
        value={value}
        onChange={handleChange}
        displayEmpty
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Calendar size={16} />
            <Typography variant="body2" fontWeight={500}>
              {selected}
            </Typography>
          </Box>
        )}
        sx={{
          bgcolor: 'background.paper',
          '& .MuiSelect-select': {
            py: 1,
          }
        }}
      >
        {Object.values(DATE_RANGES).map((range) => (
          <MenuItem key={range} value={range}>
            {range}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
